/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Initial_Credits_AmountInputs */

const en_admin_settings_fields_initial_credits_amount = /** @type {(inputs: Admin_Settings_Fields_Initial_Credits_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits amount`)
};

const zh_admin_settings_fields_initial_credits_amount = /** @type {(inputs: Admin_Settings_Fields_Initial_Credits_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积分数量`)
};

/**
* | output |
* | --- |
* | "Credits amount" |
*
* @param {Admin_Settings_Fields_Initial_Credits_AmountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_initial_credits_amount = /** @type {((inputs?: Admin_Settings_Fields_Initial_Credits_AmountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Initial_Credits_AmountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_initial_credits_amount(inputs)
	return zh_admin_settings_fields_initial_credits_amount(inputs)
});
export { admin_settings_fields_initial_credits_amount as "admin.settings.fields.initial_credits_amount" }